"use client";

import { useStyles } from "./styles";
import OptionBadges from "./OptionBadges";
import PowerLevels from "./PowerLevels";
import ModelPreview from "./ModelPreview";
import TotalImagesSelect from "../TotalImagesSelect";

interface PreviewOverviewProps {
  prompt: string;
  selectedModes: {
    isPublic: boolean;
    is18Plus: boolean;
    isTextImage: boolean;
  };
  images: File[];
  setImages: (images: File[]) => void;
  selectedModel: string;
  aspectRatio: string;
  totalImages: number;
  setTotalImages: (value: number) => void;
  onCreate: () => void;
  isScrollable?: boolean;
}

const PreviewOverview: React.FC<PreviewOverviewProps> = ({
  prompt,
  selectedModes,
  images,
  setImages,
  selectedModel,
  aspectRatio,
  totalImages,
  setTotalImages,
  onCreate,
  isScrollable = false,
}) => {
  const { classes } = useStyles({ isScrollable });

  return (
    <div className={classes.container}>
      <div className={classes.userInputDisplay}>
        <OptionBadges
          selectedModes={selectedModes}
          images={images}
          setImages={setImages}
          totalImages={totalImages}
        />
        <TotalImagesSelect
          selectedModel={selectedModel}
          totalImages={totalImages}
          setTotalImages={setTotalImages}
        />
        <button
          className={classes.createButton}
          disabled={!prompt}
          onClick={onCreate}
        >
          Create
        </button>
      </div>
      <PowerLevels selectedModel={selectedModel} />
      <ModelPreview
        aspectRatio={aspectRatio.replace(":", " / ")}
        selectedModel={selectedModel}
      />
    </div>
  );
};

export default PreviewOverview;
